/* jshint es3:true */
(function (arc, $) {
    var SCROLLING_BANNER_SELECTOR = "#scrolling-banner-container";
    var SCROLLING_BANNER_TRACK_SELECTOR = "#scrolling-banner-track";
    var SCROLLING_BANNER_VISIBLE_CLASS = "scrolling-banner-visible";
    var SCROLLING_BANNER_PAUSED_CLASS = "scrolling-banner-paused";
    var SCROLLING_BANNER_ITEM_SEPARATOR = " \u2022 ";
    var SCROLLING_BANNER_MESSAGE_CLASS = "scrolling-banner-message";
    var SCROLLING_BANNER_CLICKABLE_CLASS = "scrolling-banner-message-clickable";
    var CLICK_ACTION_DIALOG = "DIALOG";
    var CLICK_ACTION_SYSTEM_STATUS = "SYSTEM_STATUS";
    var SYSTEM_STATUS_PATH = "/systemstatus/index";
    var DEFAULT_POLL_INTERVAL_MILLIS = 60000;
    // Polling counts as activity for the session, so it stops once the user has been away for this long.
    var IDLE_LIMIT_MILLIS = 900000;
    var INTERACTION_EVENTS = "mousemove mousedown keydown wheel touchstart scroll";
    // Pointer movement arrives continuously, so activity is recorded at most this often.
    var INTERACTION_RECORD_INTERVAL_MILLIS = 1000;

    function isBlank(value) {
        return value === null || value === undefined || $.trim(String(value)).length === 0;
    }

    function escapeHtml(value) {
        return $("<div>").text(value).html();
    }

    function isClickable(message) {
        if (message.clickAction === CLICK_ACTION_SYSTEM_STATUS) {
            return true;
        }

        return message.clickAction === CLICK_ACTION_DIALOG && !isBlank(message.message);
    }

    function buildMessageMarkup(message, index) {
        var safeTitle = escapeHtml($.trim(String(message.title)));
        var classes = SCROLLING_BANNER_MESSAGE_CLASS;
        var interactionAttributes = "";

        if (isClickable(message)) {
            classes += " " + SCROLLING_BANNER_CLICKABLE_CLASS;
            interactionAttributes = " role=\"button\" tabindex=\"0\"";
        }

        return "<strong class=\"" + classes + "\" data-message-index=\"" + index + "\"" +
            interactionAttributes + ">" + safeTitle + "</strong>";
    }

    function isPageHidden() {
        return typeof document.hidden === "boolean" && document.hidden;
    }

    function ScrollingBanner(options) {
        this.options = options || {};
        this.$container = $(SCROLLING_BANNER_SELECTOR);
        this.$track = $(SCROLLING_BANNER_TRACK_SELECTOR);
        this.currentSignature = null;
        this.intervalId = null;
        this.hoverBound = false;
        this.messages = [];
        this.lastInteraction = new Date().getTime();

        if (!this.$container.length || !this.$track.length) {
            return;
        }

        this.fetchAndRender();
        this.bindHoverHandlers();
        this.bindClickHandler();
        this.bindActivityHandlers();
        this.startPolling();
    }

    /** Records the user as active and fetches straight away when the banner stopped polling. */
    ScrollingBanner.prototype.recordInteraction = function () {
        var now = new Date().getTime();
        var sinceLastInteraction = now - this.lastInteraction;

        if (sinceLastInteraction < INTERACTION_RECORD_INTERVAL_MILLIS) {
            return;
        }

        this.lastInteraction = now;

        if (sinceLastInteraction >= IDLE_LIMIT_MILLIS) {
            this.fetchAndRender();
        }
    };

    ScrollingBanner.prototype.isIdle = function () {
        return new Date().getTime() - this.lastInteraction >= IDLE_LIMIT_MILLIS;
    };

    ScrollingBanner.prototype.bindActivityHandlers = function () {
        var banner = this;

        $(document).on(INTERACTION_EVENTS, function () {
            banner.recordInteraction();
        });

        // Coming back to the tab is the user turning to the banner again, so it counts as activity.
        $(document).on("visibilitychange", function () {
            if (!isPageHidden()) {
                banner.recordInteraction();
            }
        });
    };

    ScrollingBanner.prototype.bindHoverHandlers = function () {
        if (this.hoverBound) {
            return;
        }

        this.$container.on("mouseenter", function () {
            $(this).addClass(SCROLLING_BANNER_PAUSED_CLASS);
        });

        this.$container.on("mouseleave", function () {
            $(this).removeClass(SCROLLING_BANNER_PAUSED_CLASS);
        });

        this.hoverBound = true;
    };

    ScrollingBanner.prototype.bindClickHandler = function () {
        var banner = this;

        this.$track.on("click keydown", "." + SCROLLING_BANNER_CLICKABLE_CLASS, function (event) {
            if (event.type === "keydown" && event.which !== 13 && event.which !== 32) {
                return;
            }

            var index = parseInt($(this).attr("data-message-index"), 10);
            var message = banner.messages[index];

            if (!message) {
                return;
            }

            event.preventDefault();
            banner.handleMessageClick(message);
        });
    };

    ScrollingBanner.prototype.handleMessageClick = function (message) {
        if (message.clickAction === CLICK_ACTION_SYSTEM_STATUS) {
            window.location.href = arc.defaultContextPath + SYSTEM_STATUS_PATH;
            return;
        }

        if (message.clickAction === CLICK_ACTION_DIALOG) {
            showNoticeDialog(message.message, message.title);
        }
    };

    ScrollingBanner.prototype.startPolling = function () {
        var banner = this;
        var pollInterval = parseInt(this.options.pollIntervalMillis, 10);

        if (this.intervalId) {
            window.clearInterval(this.intervalId);
        }

        if (isNaN(pollInterval) || pollInterval <= 0) {
            pollInterval = DEFAULT_POLL_INTERVAL_MILLIS;
        }

        this.intervalId = window.setInterval(function () {
            // A request of its own keeps the session alive, so a banner nobody watches must not send one.
            if (isPageHidden() || banner.isIdle()) {
                return;
            }

            banner.fetchAndRender();
        }, pollInterval);
    };

    ScrollingBanner.prototype.fetchAndRender = function () {
        var banner = this;

        $.ajax({
            url: arc.defaultContextPath + "/service/notification/getScrollingBannerMessages",
            type: "GET",
            cache: false,
            dataType: "json"
        }).done(function (messages) {
            banner.render(messages);
        }).fail(function () {
            banner.render([]);
        });
    };

    ScrollingBanner.prototype.render = function (messages) {
        var safeMessages = $.isArray(messages) ? messages : [];
        var normalized = [];
        var i;

        for (i = 0; i < safeMessages.length; i++) {
            if (safeMessages[i] && !isBlank(safeMessages[i].title)) {
                normalized.push({
                    id: safeMessages[i].id,
                    title: safeMessages[i].title,
                    message: safeMessages[i].message,
                    clickAction: safeMessages[i].clickAction
                });
            }
        }

        if (!normalized.length) {
            this.hide();
            this.currentSignature = null;
            return;
        }

        var signature = JSON.stringify(normalized);
        if (signature === this.currentSignature) {
            return;
        }

        this.currentSignature = signature;
        this.show(normalized);
    };

    ScrollingBanner.prototype.show = function (messages) {
        var i;
        var messageMarkup = [];
        var plainTexts = [];

        this.messages = messages;

        for (i = 0; i < messages.length; i++) {
            messageMarkup.push(buildMessageMarkup(messages[i], i));
            plainTexts.push(messages[i].title);
        }

        var text = plainTexts.join(SCROLLING_BANNER_ITEM_SEPARATOR);

        this.$track.html(messageMarkup.join("<span aria-hidden=\"true\">" + SCROLLING_BANNER_ITEM_SEPARATOR + "</span>"));
        this.$track.attr("aria-label", text);

        // Scale animation speed with content length to keep text readable.
        var durationInSeconds = Math.max(20, Math.ceil(text.length / 6)) * 2;
        this.$track.css("animation", "none");
        // Reading offsetHeight forces a reflow so the animation restarts.
        void this.$track[0].offsetHeight;
        this.$track.css("animation", "scrolling-banner-marquee " + durationInSeconds + "s linear infinite");

        this.$container.removeClass("hidden");
        $("body").addClass(SCROLLING_BANNER_VISIBLE_CLASS);
    };

    ScrollingBanner.prototype.hide = function () {
        this.$container.addClass("hidden");
        this.$container.removeClass(SCROLLING_BANNER_PAUSED_CLASS);
        this.$track.css("animation", "none");
        $("body").removeClass(SCROLLING_BANNER_VISIBLE_CLASS);
    };

    arc.scrollingBanner = function (options) {
        return new ScrollingBanner(options);
    };

    if (!arc.scrollingBannerInitialised) {
        arc.scrollingBannerInitialised = true;
        $(function () {
            arc.scrollingBanner({
                pollIntervalMillis: $i.scrollingBannerPollIntervalMillis
            });
        });
    }
})(arc, jQuery);
